import React from 'react';
import Avatar from 'material-ui/Avatar';
import IconButton from 'material-ui/IconButton';
import Menu, { MenuItem } from 'material-ui/Menu';
import { withRouter } from "react-router-dom";
import moment from 'moment'

class CardMenu extends React.Component {

    render() {
        const ITEM_HEIGHT = 40;
        const options = [
            { id: 1, name: 'View / Update' },
            // { id: 2, name: 'Delete' },
        ];
        const { menuState, anchorEl, handleRequestClose } = this.props;
        return (
            <Menu id="long-menu"
                anchorEl={anchorEl}
                open={menuState}
                onClose={handleRequestClose}
                style={{ maxHeight: ITEM_HEIGHT * 4.5 }}
                MenuListProps={{
                    style: {
                        width: 150,
                        paddingTop: 0,
                        paddingBottom: 0
                    },
                }}>
                {options.map(option =>
                    <MenuItem key={option.id} onClick={handleRequestClose.bind(this, option.id)}>
                        {option.name}
                    </MenuItem>,
                )}
            </Menu>
        );
    }

}

class TableCell extends React.Component {

    onOptionMenuSelect = event => {
        this.setState({ menuState: true, anchorEl: event.currentTarget });
    };
    handleRequestClose(data, click_id, e) {
        // console.log('handleClick', click_id);
        if (click_id == 1) {
            // console.log('this.state.open out1', this.state.openDialog);
            // this.props.actions.setMeetingDetails(data);
            this.props.history.push('/customer/add-customer/' + data.id);
        }
        else if (click_id == 2) {
            // this.setState({open: true});
        }
        else if (click_id == 3) {
            // this.setState({open: true});
        }
        else if (click_id == 4) {
            // console.log(this.props)
            // this.props.history.push('/user/add-user/' + userid);
        }
        this.setState({ menuState: false });
    };

    constructor() {
        super();
        this.state = {
            anchorEl: undefined,
            menuState: false,
        }
    }

    render() {
        const { anchorEl, menuState } = this.state;
        const { id, customer_name, contact_name, email_id, customer_mb_no, subcription_date, status } = this.props.data;
        const index = this.props.index;
        return (
            <tr tabIndex={-1} key={index}>
                <td>{index + 1}</td>
                <td>{customer_name}</td>
                <td>{contact_name}</td>
                <td>{email_id}</td>
                <td>{customer_mb_no}</td>
                <td>{moment(subcription_date).format('DD/MM/YYYY')}</td>
                <td className="text-right">
                    <IconButton className="size-30" onClick={this.onOptionMenuSelect.bind(this)}>
                        <i className="zmdi zmdi-more-vert" /></IconButton>
                    <CardMenu menuState={menuState} anchorEl={anchorEl}
                        handleRequestClose={this.handleRequestClose.bind(this, this.props.data)} />
                </td>
            </tr>

        );
    }
}

export default withRouter(TableCell);



// WEBPACK FOOTER //
// ./app/customerdetails/customerlist/tablecell.js